var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`size-${_vm.size} ${_vm.iconClass}`,staticStyle:{"min-width":"15px","min-height":"15px","width":"15px","height":"15px"},domProps:{"innerHTML":_vm._s(_vm.iconSvg(_vm.name))}})
}
var staticRenderFns = []

export { render, staticRenderFns }